export default {
  CSV: '.csv',
  JPG: '.jpg',
  PNG: '.png',
};
